<template>
    <div class="dialog">
        <el-dialog
            title="预约须知"
            :visible.sync="showDig"
            width="50%"
            :show-close="false"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            top="15vh"
        >
            <div class="section">
                <div v-html="html"></div>
            </div>
            <div slot="footer" class="dialog-footer flex-row">
                <el-button @click="showDig = false">我已知晓</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
// 引入公共的bus，来做为中间传达的工具
import { eventBus } from "../../utils/eventBus.js";
export default {
    name: "Tips",
    props: {
        show: {
            type: Boolean,
            default: false,
        },
        html: [String],
    },
    computed: {
        showDig: {
            get: function () {
                return this.show;
            },
            set: function (value) {
                this.$emit("update:show", value);
                return value;
            },
        },
    },
    data() {
        return {
            currentTab: "",
            show1: true,
        };
    },
    mounted() {},
    methods: {},
};
</script>

<style scoped>
.content .dialog-footer {
    justify-content: center;
}

.section {
    font-size: 16px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    max-height: 500px;
    /* overflow: hidden; */
    overflow-y: scroll;
    line-height: 1.5;
}

/deep/ .el-dialog__header {
    height: 42px;
    background: #bb2916;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0 24px;
    box-sizing: border-box;
    justify-content: space-between;
}

/deep/ .el-dialog__body {
    padding: 32px;
    box-sizing: border-box;
}

/deep/ .el-dialog__title {
    font-size: 16px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff !important;
}

/deep/ .el-dialog__headerbtn {
    width: 16px;
    height: 16px;
    position: inherit;
}

/deep/ .el-dialog__headerbtn .el-dialog__close {
    color: #ffffff !important;
}

/deep/ .dialog-footer .el-button:first-child {
    width: 374px;
    height: 60px;
    background: #ffffff;
    border-radius: 30px;
    border: 1px solid #bb2916;
    font-size: 16px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #bb2916;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 20px;
}

/deep/ .dialog-footer .el-button:last-child {
    width: 374px;
    height: 60px;
    background: #bb2916;
    border-radius: 30px;
    font-size: 16px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
